import {Injectable} from "@angular/core";
import {ObjectDTO} from "../../dtos/object-dto";
import {UtilsService} from "../../utils/utils.service";
import {Auth2Service} from "../security/auth2.service";
import {HttpService} from "../technique/http.service";
import {GraphQLService} from "../technique/graphql.service";
import {Observable, Subject} from "rxjs";
import {catchError} from "rxjs/operators";
import {ResponseWrapper} from "../../suppliers/wrappers/response-wrapper";
import {FamilleFacturationDto} from "../../dtos/facturation/clients/famille-facturation/famille-facturation-dto";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FamilleFacturationService {

  private subjectOpenDialog = new Subject<FamilleFacturationDto>();
  openDialogEdition$ = this.subjectOpenDialog.asObservable();

  private subjectFamilleFacturationSaved = new Subject<FamilleFacturationSavedSupplier>();
  familleFacturationSaved$ = this.subjectFamilleFacturationSaved.asObservable();


  constructor(private utils: UtilsService,
              private auth2Svc: Auth2Service,
              private httpSvc: HttpService,
              private graphQlSvc: GraphQLService
  ) {}

  announceOpenDialogEdition = (element: FamilleFacturationDto) => {
    this.subjectOpenDialog.next(element);
  };

  announceElementFacturableSaved = (familleFacturation: FamilleFacturationDto, isUpdate: boolean = false) => {
    this.subjectFamilleFacturationSaved.next({isUpdate, familleFacturation: familleFacturation} as FamilleFacturationSavedSupplier);
  };

  save = (elementFact: FamilleFacturationDto): Observable<ResponseWrapper<FamilleFacturationDto>> => {
    return this.httpSvc.post("dolrest/famille-facturation/save", elementFact);
  }


  findAllFamillesFacturation = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
        allFamilleFacturation(filters: {
          siteIds: [${this.auth2Svc.utilisateur.sites.map(s => s.id)}]
        }) {
            id,
            code,
            libelle,
            site {
                id,
                libelle,
            },
        }
      }
    `).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  canModify(element: ObjectDTO): boolean {
    if (!element || !element?.site || !element?.site.id) {
      return true;
    }
    return this.auth2Svc.isSiteLocal(element.site.id);
  }

  deleteFamilleFacturation = (ids: number[]) => {
    const params: HttpParams = new HttpParams().set('ids', ids.join(','));
    return this.httpSvc.delete(`dolrest/famille-facturation/delete`, params).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

}

export interface FamilleFacturationSavedSupplier {
  isUpdate: boolean;
  familleFacturation: FamilleFacturationDto;
}
